import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  padding: 16px 24px 24px;
  height: 100%;
`;

export const Title = styled.div`
  flex: 1;
  color: ${beam.font.primary};
  font-size: 16px;
  font-weight: 500;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
`;

export const Close = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  border-radius: 8px;
  padding-top: 6px;
  width: 32px;
  height: 32px;

  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
  background-color: transparent;
  border: 0;
  margin-right: 10px;

  :hover {
    background-color: #f6f8ff;
    border-radius: 8px;
  }
`;

export const Lines = styled.div`
  border-top: 1px solid ${beam.lines.white};
  border-bottom: 1px solid ${beam.lines.white};
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 40px;

  & + & {
    border-top: 1px solid ${beam.lines.white};
  }
`;

export const Name = styled.div`
  flex: 1;
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  margin: 0 8px;
`;

export const Bottom = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
`;

interface IBottomText {
  disabled?: boolean;
}

export const BottomText = styled.button<IBottomText>`
  height: 42px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const BottomButton = styled.button`
  border: none;
  box-shadow: 1px 1px 5px 0 #323b5433;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${beam.color.primaryBlue};
  background: ${beam.color.pureWhite};
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 16px;
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;
export const Search = styled.input`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.placeholder.primary};
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: ${beam.placeholder.primary};
  }
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow: auto;
  margin-top: 24px;
  height: 335px;
  & > div {
    margin-left: 0 !important;
    margin-bottom: 16px !important;
  }

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
export const PlusButton = styled.button`
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  background: none;
  border: none;
  background: #1371fe;
  box-shadow: 0px 1px 4px rgba(19, 113, 254, 0.7);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  margin-bottom: 8px;
  margin-left: 8px;
`;
